/**
 * HOC Component who make lazy load
 *
 * @flow
 */
import * as React from 'react';

type State = {
  Component: ?any;
}

export default function asyncComponent(getComponent: () => Promise<any>, loadingComponent?: React.Element<any>) {
  return class AsyncComponent extends React.Component<void, State> {
    state = {
      Component: null,
    };

    componentWillMount() {
      this.setState({
        Component: null,
      });
      getComponent().then((mod) => {
        this.setState({
          Component: mod.default ? mod.default : mod,
        });
      });
    }

    render() {
      const { Component } = this.state;

      if (Component) {
        return <Component {...this.props} />;
      }

      if (loadingComponent) {
        return loadingComponent;
      }

      return null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/helpers/asyncComponent.js